import { Focus_ } from 'monica-alexandria';
import styled from 'styled-components';

const OfferPreviewPaymentAnchor = styled.a`
    display: inline-flex;
    text-decoration: none;
`;

export default function Offer_Preview_Payment_Action(props) {
    let actionText = props.paymentText;

    if (props.isInitiating) {
        actionText = props.copy.processing;
    } else if (!props.paymentLinkUrl.length && props.usesBankTransfer) {
        actionText = props.copy.proceedBankTransfer;
    }

    return (
        <>
            {props.paymentLinkUrl.length ? (
                <OfferPreviewPaymentAnchor
                    href={props.paymentLinkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(event) => props.onProceedToLink(event, props.paymentType)}
                >
                    <Focus_
                        size="large"
                        text={actionText}
                        iconRight="Next"
                    ></Focus_>
                </OfferPreviewPaymentAnchor>
            ) : (
                <Focus_
                    size="large"
                    text={actionText}
                    iconRight="Next"
                    onClick={() => props.onProceed(props.paymentType)}
                ></Focus_>
            )}
        </>
    );
}
